import { Alert, CircularProgress, Grid } from '@mui/material'
import { Box } from 'components'
import { useLoadOrderCommercialReferences } from 'modules/orders/hooks'
import { useOrderStore } from 'modules/orders/store'
import { useFormContext, useFieldArray } from 'react-hook-form'
import { SelectPaymentTerms } from '../../SelectPaymentTerms'

import InstallmentsView from './installments'
import { useRecalculeItems } from '../useRecalculeItems'
import { RecalculeAlert } from '../../recalculeAlert'

export default function Payment() {
  const { watch } = useFormContext()

  const [paymentTerm, paymentResponsible] = watch([
    'paymentTerm',
    'paymentResponsible'
  ])

  const { data: commercialReference } = useLoadOrderCommercialReferences({
    customerId: paymentResponsible?.id
  })

  const isRecalculatingDuplicateOrder =
    useOrderStore.useIsRecalculatingDuplicateOrder()
  const setForm = useOrderStore.useSetForm()

  const { isLoading: isRecalculating } = useRecalculeItems({
    enabled: !isRecalculatingDuplicateOrder
  })

  const { remove } = useFieldArray({
    name: 'installments'
  })

  const hasCommercialRefsEnough =
    (commercialReference?.total || 0) >=
    (Number(paymentTerm?.requiredRefs) || 0)

  const hasPaymentResponsible = paymentResponsible?.id

  return (
    <Box
      style={{
        width: '100%',
        padding: 12
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RecalculeAlert />
        </Grid>
        <Grid item xs={12}>
          <SelectPaymentTerms
            disabled={isRecalculating}
            onChange={() => {
              remove()
              // Na duplicação, o snapshot guarda as parcelas da condição de
              // pagamento original. Ao trocar a condição ele deixa de valer;
              // se mantido, o InstallmentsView reaproveita a quantidade e os
              // valores antigos em vez de usar as parcelas da nova condição.
              setForm({ duplicateInstallmentsSnapshot: [] })
            }}
          />
        </Grid>
        {isRecalculating && (
          <Grid item xs={22}>
            <Alert
              severity="info"
              icon={<CircularProgress style={{ marginTop: 3 }} size={16} />}
            >
              Buscando novos preços de tabela!
            </Alert>
          </Grid>
        )}
        {paymentTerm?.requiredRefs && (
          <Grid item xs={12}>
            <>
              {!hasCommercialRefsEnough && (
                <Alert severity="warning">
                  Faltam referências comerciais (total:{' '}
                  {commercialReference?.total || 0} {' requerida: '}
                  {paymentTerm?.requiredRefs || 0})
                </Alert>
              )}
              {hasCommercialRefsEnough && (
                <Alert severity="success">
                  Referências comerciais (total:{' '}
                  {commercialReference?.total || 0} {' requerida: '}
                  {paymentTerm?.requiredRefs || 0})
                </Alert>
              )}
            </>
          </Grid>
        )}
        {!hasPaymentResponsible && (
          <Grid item xs={12}>
            <Alert severity="warning">
              Responsável por pagamento não selecionado
            </Alert>
          </Grid>
        )}

        <InstallmentsView disabled={isRecalculating} />
      </Grid>
    </Box>
  )
}
